export default "__VITE_ASSET__67cfe8ff__"